<template>
  <el-dialog
    class="mapVisible"
    v-model="show"
    :title="title"
    title-align="“start”"
    width="1200px"
    :before-close="cancelMap"
  >
    <myMmap
      @finesedok="finesedok"
      @zb="zbChange"
      :center="center"
      :list="list"
      :showIcon="showIcon"
      :type="type"
    ></myMmap>
    <template #footer>
      <div class="dialog-footer">
        <div class="tipT" v-if="jw.lon">
          坐标:{{ jw.lon + "," + jw.lat }},地址:{{ jw.address }}
        </div>
        <div class="rightBox">
          <el-button @click="cancelMap()">取消</el-button>
          <el-button type="primary" @click="confirmMap()">确定</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>
    
    <script>
import myMmap from "@/components/map/mapModel.vue";
import { onMounted, ref, watch, computed } from "vue";
export default {
  name: "sznc-map",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Array,
      default: [],
    },
    list: {
      type: Array,
      default: [],
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "1",
    },
    title: {
      type: String,
      default: "绘制基地",
    },
  },
  components: { myMmap },
  setup(props, context) {
    const confirmMap = () => {
      // jw为经纬度信息
      //mapval
      context.emit("confirm", {
        jw: jw.value,
        list: mapval.value,
      });
    };

    const show = computed({
      get: () => props.show,
      set: (value) => {
        // emit('update:modelValue', value)
      },
    });
    const center = computed({
      get: () => props.center,
      set: (value) => {
        if(props.center.length>0){
          return ["116.39126", "39.90713"]
        }else{
          if(localStorage.setItem("mapCentre", result.mapCentre)){
              return localStorage.setItem("mapCentre", result.mapCentre).split(',')
          }else{
            return ["116.39126", "39.90713"]
          }
          
        }
        // emit('update:modelValue', value)
      },
    });
    const list = computed({
      get: () => props.list,
      set: (value) => {
        // emit('update:modelValue', value)
      },
    });
    const showIcon = computed({
      get: () => props.showIcon,
      set: (value) => {
        // emit('update:modelValue', value)
      },
    });
    const type = computed({
      get: () => props.type,
      set: (value) => {
        // emit('update:modelValue', value)
      },
    });
    const title = computed({
      get: () => props.title,
      set: (value) => {
        // emit('update:modelValue', value)
      },
    });
    const cancelMap = () => {
      // jw为经纬度信息
      //mapval
      context.emit("cancel");
    };
    let mapval = ref([]);
    const jw = ref({});
    const finesedok = (val) => {
      mapval.value = val;
      // if (mapval.value.length > 0) {
      //   jw.value = calculateCenter(mapval.value);
      // }
      
    };
    const zbChange = (e) => {
      jw.value = e;
    };

    return {
      confirmMap,
      cancelMap,
      finesedok,
      zbChange,
      center,
      jw,
      show,
      list,
      showIcon,
      type,
      title,
    };
  },
};
</script>
    
    
    <!-- Add "scoped" attribute to limit CSS to this component only -->
    
     <style lang="less">
.el-dialog .el-dialog__footer .dialog-footer {
  display: flex;
  justify-content: space-between;
  .tipT {
    color: #666666;
    line-height: 36px;
  }
  .rightBox {
    margin-left: auto;
  }
}
.dialog-footer {
  border: none !important;
}
</style>
    